import React from 'react';

import bg_img from '../../css/bg.svg'

class Result extends React.Component {
	
    componentDidMount = () => {
    }
	
    componentDidUpdate = () => {
    }
	
	colorize = (clsName, arkaneValue) => {
		if ( this.props.digitsCount[arkaneValue] > 2 ) {
			return this.format(clsName + " green-text", arkaneValue);
		}
		if ( this.props.digitsCount[arkaneValue] > 1 ) {
			return this.format(clsName + " red-text", arkaneValue);
		}
		return this.format(clsName, arkaneValue);
	}

	format = (clsName, arkaneValue) => {
		if ( arkaneValue > 9 ) {
			//return clsName + " point--two-numbers";
			return clsName;
		}
		return clsName;
	}

	render = () => {

        //console.log('props', this.props);
		// red-text
		// green-text

		let arkanes_link_part = `${this.props.arkanes[1]}_${this.props.arkanes[2]}_${this.props.arkanes[3]}_${this.props.arkanes[4]}_${this.props.arkanes[5]}_${this.props.arkanes[6]}_${this.props.arkanes[7]}_${this.props.arkanes[8]}_${this.props.arkanes[9]}`
		let params_link_part = `${this.props.soulAge}_${this.props.innerChild}_${this.props.energyArkanes.k}`
		let energy_link_part = `${this.props.energyArkanes.m}${ this.props.maleIsFlipped ? 'm' : '' }_${this.props.energyArkanes.f}${ this.props.femaleIsFlipped ? 'm' : '' }`
		let larma_link_part = String(this.props.longKarma).replace(", ", "x").replace(", ", "x").replace(", ", "x").replace(",", "x").replace(",", "x").replace(",", "x");
		let bot_link = `https://t.me/num_navigator_bot?start=wlcres_${arkanes_link_part}p${params_link_part}e${energy_link_part}k${larma_link_part}`;
		return (
			<div className={"result"} style={{display: "flex"}}>
				<h2 className={"h2margin"}>Ваша дата рождения<br/><span>{`${this.props.birthDayInput}.${this.props.birthMonthInput}.${this.props.birthYearInput}`}</span></h2>
				<div className={"container data"}>
					<div className={"figure"} style={{backgroundImage: `url(${bg_img})`}}>
						<span className={this.format("point point-1", this.props.arkanes[1])}><div>{this.props.arkanes[1]}</div></span>
						<span className={this.format("point point-2", this.props.arkanes[2])}><div>{this.props.arkanes[2]}</div></span>
						<span className={this.format("point point-3", this.props.arkanes[3])}><div>{this.props.arkanes[3]}</div></span>
						<span className={this.format("point point-4", this.props.arkanes[4])}><div>{this.props.arkanes[4]}</div></span>
						<span className={this.format("point point-5", this.props.arkanes[5])}><div>{this.props.arkanes[5]}</div></span>
						<span className={this.format("point point-6", this.props.arkanes[6])}><div>{this.props.arkanes[6]}</div></span>
						<span className={this.format("point point-7", this.props.arkanes[7])}><div>{this.props.arkanes[7]}</div></span>
						<span className={this.format("point point-8", this.props.arkanes[8])}><div>{this.props.arkanes[8]}</div></span>
						<span className={this.format("point point-9", this.props.arkanes[9])}><div>{this.props.arkanes[9]}</div></span>
					</div>
					<div className={"information"}>
						<p>Возраст души:<span className={"information_value information_age-soul red-text"}>{this.props.soulAge}</span></p>
						<p>Внутренний ребенок:<span className={"information_value information_male-arc red-text"}>{this.props.innerChild}</span></p>
						<p>Долгосрочная карма:<span className={"information_value information_female-arc red-text"}>{this.props.longKarma}</span></p>
						{/*<p>Нейтральные арканы:<span className={"information_value information_light-arc red-text"}>{this.props.genderArkanes.n}</span></p>*/}
						<p>Кармические арканы:<span className={"information_value information_carm-arc red-text"}>{this.props.energyArkanes.k}</span></p>
						<p>М/Ж энергии:
							<span className={"information_value information_energy red-text"}>
								{this.props.energyArkanes.m}{ this.props.maleIsFlipped ? '-' : '' }
								/
								{this.props.energyArkanes.f}{ this.props.femaleIsFlipped ? '-' : '' }
							</span>
						</p>
					</div>
				</div>
				<p>Хотите узнать больше, переходите в бот <b>Цифровой навигатор</b> и узнайте о себе всё по дате рождения</p>
				<p>⏬⏬⏬</p>
				{/*<button onClick={this.props.onDecode} className={"button button--red "}>Расшифровка</button>*/}
				<a href={bot_link} className={"button button--red "} target="_blank" rel="noopener noreferrer">Расшифровка</a>
				<div className={"container buttons"}>
					<button className={"button"} onClick={this.props.onReset}>Рассчитать заново</button>
				</div>
    		</div>
		);
	}

}

export default Result;
